import { schemes, zSchema } from "@zeal/common";
import { Jurisdiction } from "@zeal/common";

export const getEWAPoliciesRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  ewaPolicyID: schemes.uuid().optional(),
  stateJurisdiction: zSchema.nativeEnum(Jurisdiction).optional(),
});

export type TGetEWAPoliciesRequestSchema = zSchema.infer<
  typeof getEWAPoliciesRequestSchema
>;

export const ewaPolicySchema = zSchema.object({
  ewaPolicyID: zSchema.string(),
  companyID: schemes.companyID(),
  stateJurisdiction: zSchema.nativeEnum(Jurisdiction),
  maxEwaPercentage: zSchema.number(),
  effectiveStartDate: zSchema.string(),
  effectiveEndDate: zSchema.string(),
});

export type TEWAPolicySchema = zSchema.infer<typeof ewaPolicySchema>;

export const getEWAPoliciesResponseSchema = zSchema.union([
  ewaPolicySchema,
  zSchema.array(ewaPolicySchema),
]);

export type TGetEWAPoliciesResponseSchema = zSchema.infer<
  typeof getEWAPoliciesResponseSchema
>;
